import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { defaultThemeColors, fonts, mediaSizes } from "ui/theme";
import { TestimonialCard } from "./TestimonialCard";

const testimonials = [
  {
    id: 1,
    name: "Sarah L.",
    avatar:
      "https://images.pexels.com/photos/1181686/pexels-photo-1181686.jpeg?auto=compress&cs=tinysrgb&w=200",
    rating: 5,
    quote:
      "Joining Teache has been a game-changer for my teaching career. As an independent Piano instructor, I struggled to find students consistently. With Teache, I can easily list my classes, manage my schedule, and connect with students in my community. The platform is user-friendly, and the support team is fantastic. I've seen a significant increase in my bookings, and the authentic reviews from my students have helped me build a solid reputation.",
  },
  {
    id: 2,
    name: "John D.",
    avatar:
      "https://images.pexels.com/photos/1040881/pexels-photo-1040881.jpeg?auto=compress&cs=tinysrgb&w=200",
    rating: 5,
    quote:
      "Teache has made learning new skills so much easier and more accessible. I was able to find a cooking class just a few blocks from my home, taught by an experienced chef. The booking process was straightforward. The class was fantastic, and I've already signed up for another one. The variety of classes available on Teache is impressive, and I love that I can support local instructors.",
  },
  {
    id: 3,
    name: "Patricia W.",
    avatar:
      "https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?auto=compress&cs=tinysrgb&w=200",
    rating: 5,
    quote:
      "Teache has completely transformed the way I run my classes. As an independent instructor, it was always challenging to reach new students and manage bookings. With Teache, I can easily showcase my classes, organize my schedule, and connect with people who are genuinely interested in learning. I've noticed a steady growth in my bookings, and the reviews from my students have helped me build trust and credibility.",
  },
  {
    id: 4,
    name: "Marcus T.",
    avatar:
      "https://images.pexels.com/photos/2379005/pexels-photo-2379005.jpeg?auto=compress&cs=tinysrgb&w=200",
    rating: 5,
    quote:
      "I've been teaching guitar for over 10 years and Teache helped me reach students I never would have found otherwise. The platform handles the admin side so I can focus entirely on teaching. My schedule is always full and the students I meet through Teache are genuinely motivated to learn.",
  },
  {
    id: 5,
    name: "Elena R.",
    avatar:
      "https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=200",
    rating: 5,
    quote:
      "Finding a piano teacher who fits my schedule used to be so stressful. Teache made it effortless. I browsed profiles, read real reviews, and booked a trial lesson within minutes. My instructor is incredibly talented and the whole experience has been wonderful. I look forward to every class.",
  },
  {
    id: 6,
    name: "David K.",
    avatar:
      "https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg?auto=compress&cs=tinysrgb&w=200",
    rating: 5,
    quote:
      "As someone who wanted to pick up drumming later in life, I wasn't sure where to start. Teache connected me with a local instructor who was patient, encouraging, and incredibly skilled. Three months in, I'm playing songs I never thought I'd be able to tackle. This platform is genuinely life-changing.",
  },
  {
    id: 7,
    name: "Aisha M.",
    avatar:
      "https://images.pexels.com/photos/1181690/pexels-photo-1181690.jpeg?auto=compress&cs=tinysrgb&w=200",
    rating: 5,
    quote:
      "I teach violin and was looking for a better way to connect with serious students. Teache delivered exactly that. The quality of students I've met through the platform is outstanding — they come prepared, they're committed, and the lessons are incredibly rewarding for both of us.",
  },
  {
    id: 8,
    name: "Carlos B.",
    avatar:
      "https://images.pexels.com/photos/1040880/pexels-photo-1040880.jpeg?auto=compress&cs=tinysrgb&w=200",
    rating: 5,
    quote:
      "Teache is the best discovery I've made this year. I found a DJ instructor near me who had incredible industry experience and the lessons were fantastic. The booking process was seamless and I felt confident every step of the way. Highly recommend to anyone wanting to learn something new.",
  },
  {
    id: 9,
    name: "Linda S.",
    avatar:
      "https://images.pexels.com/photos/1181695/pexels-photo-1181695.jpeg?auto=compress&cs=tinysrgb&w=200",
    rating: 5,
    quote:
      "The community on Teache is incredible. As a singing coach, I've met students from all walks of life and built lasting relationships through the platform. The review system keeps everyone accountable and helps new students feel safe booking their first lesson. I'm proud to be part of this community.",
  },
  {
    id: 10,
    name: "Omar H.",
    avatar:
      "https://images.pexels.com/photos/1081685/pexels-photo-1081685.jpeg?auto=compress&cs=tinysrgb&w=200",
    rating: 5,
    quote:
      "I was skeptical at first but Teache won me over completely. I found a saxophone teacher within a day, the first lesson was amazing, and I've been hooked ever since. The platform is beautifully designed and everything just works. No friction, no confusion — just great learning experiences.",
  },
  {
    id: 11,
    name: "Fiona C.",
    avatar:
      "https://images.pexels.com/photos/1181676/pexels-photo-1181676.jpeg?auto=compress&cs=tinysrgb&w=200",
    rating: 5,
    quote:
      "Running my cello classes through Teache has given me so much more time to focus on what I love — teaching. The platform handles bookings, reminders, and payments seamlessly. My students love the experience and keep coming back. It's the professional infrastructure I always wished I had.",
  },
  {
    id: 12,
    name: "James P.",
    avatar:
      "https://images.pexels.com/photos/1043474/pexels-photo-1043474.jpeg?auto=compress&cs=tinysrgb&w=200",
    rating: 5,
    quote:
      "Learning bass guitar on Teache has been one of the best decisions I've made. My instructor is talented, structured, and genuinely passionate about teaching. The platform made it so easy to find someone who matched my style and skill level. I can't imagine learning any other way now.",
  },
  {
    id: 13,
    name: "Priya N.",
    avatar:
      "https://images.pexels.com/photos/1181688/pexels-photo-1181688.jpeg?auto=compress&cs=tinysrgb&w=200",
    rating: 5,
    quote:
      "As a busy professional, I need flexibility in my schedule. Teache gives me exactly that. I can browse available slots, book instantly, and reschedule when needed. My trumpet instructor is patient and adaptable. I've made more progress in two months on Teache than I did in a year of casual practice.",
  },
  {
    id: 14,
    name: "Tom W.",
    avatar:
      "https://images.pexels.com/photos/1043473/pexels-photo-1043473.jpeg?auto=compress&cs=tinysrgb&w=200",
    rating: 5,
    quote:
      "I teach music production and Teache has completely changed my reach. Students from across the city have found me through the platform. The profile system lets me showcase my work properly and the booking flow is smooth for both me and my students. It's a professional-grade tool.",
  },
  {
    id: 15,
    name: "Nadia F.",
    avatar:
      "https://images.pexels.com/photos/1181671/pexels-photo-1181671.jpeg?auto=compress&cs=tinysrgb&w=200",
    rating: 5,
    quote:
      "Teache helped me reconnect with music after years away from it. I found a wonderful piano teacher who adapted completely to my pace and goals. Every lesson feels personal and encouraging. The platform itself is so easy to use and the whole experience has been genuinely joyful.",
  },
];

const PER_GROUP = 3;
const AUTO_INTERVAL = 10000;

const chunkGroups = (items, size) => {
  const groups = [];
  for (let i = 0; i < items.length; i += size) {
    groups.push(items.slice(i, i + size));
  }
  return groups;
};

export const Testimonials = () => {
  const [current, setCurrent] = useState(0);
  const intervalRef = useRef(null);
  const groups = chunkGroups(testimonials, PER_GROUP);
  const totalGroups = groups.length;

  const startAuto = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setCurrent((prev) => (prev + 1) % totalGroups);
    }, AUTO_INTERVAL);
  };

  useEffect(() => {
    startAuto();
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  const goTo = (index) => {
    setCurrent(index);
    startAuto();
  };

  return (
    <Section>
      <Title>Testimonials</Title>

      <Viewport>
        <Track offset={current}>
          {groups.map((group, gi) => (
            <Slide key={gi}>
              {group.map((t) => (
                <TestimonialCard key={t.id} testimonial={t} />
              ))}
            </Slide>
          ))}
        </Track>
      </Viewport>

      {/* TODO: do we need to increase scale for selected slide */}
      <Dots role="tablist" aria-label="Testimonial groups">
        {groups.map((_, i) => (
          <Dot
            key={i}
            $isActive={i === current}
            onClick={() => goTo(i)}
            aria-label={`Go to group ${i + 1}`}
            role="tab"
            aria-selected={i === current}
            type="button"
          />
        ))}
      </Dots>
    </Section>
  );
};

const Section = styled.section`
  width: 100%;
  overflow: hidden;
  padding-bottom: 1rem;
`;

const Title = styled.h2`
  font-size: ${fonts.sizes['h2.1']};
  font-weight: 600;
  color: ${defaultThemeColors.basicBlack};
  text-align: center;
  margin: 0 0 48px 0;  
  
  @media (max-width: ${mediaSizes.md}) {
      font-size: 26px;
  }

  @media (max-width: ${mediaSizes.xs}) {
      font-size: 22px;
  }  
`;

const Viewport = styled.div`
  width: 100%;
  overflow: hidden;
`;

const Track = styled.div`
  display: flex;
  transform: translateX(${({ offset }) => -offset * 100}%);
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: transform;
`;

const Slide = styled.div`
  min-width: 100%;
  display: flex;
  gap: 20px;
  align-items: stretch;
  box-sizing: border-box;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

const Dots = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 40px;
  padding: 4px;
`;

const Dot = styled.button`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${({ $isActive }) => ($isActive ? "#1d1d1f" : "#d4cfc7")};
  border: none;
  padding: 0;
  cursor: pointer;
  transition:
    background-color 0.25s ease,
    transform 0.25s ease;
  transform: ${({ $isActive }) => ($isActive ? "scale(1.2)" : "scale(1)")};
`;
